import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IAPIState } from "shared/types";
import { Modal } from "shared/components";

import { dataMetaSelector } from "Bands/state";
import { DeleteBandForm } from "Bands/components";
import { BAND_ACTIONS } from "Bands/types";
import { deleteBand } from "Bands/state";
import { useBandContext } from "Bands/contexts";
import { useClearActionMetaOnUnMount } from "Bands/utils";

interface DeleteBandModalProps {
  handleClose: () => void;
}

export const DeleteBandModal: React.FC<DeleteBandModalProps> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const { bandId, band } = useBandContext();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteBand));
  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteBand);

  const handleDelete = () => {
    if (!bandId) return;

    dispatch(deleteBand(bandId));
  };

  return (
    <Modal data-testid="band_delete_modal">
      <DeleteBandForm
        bandName={band?.title || ""}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        hasError={apiMeta?.status === IAPIState.failed}
        handleClose={handleClose}
        handleDelete={handleDelete}
        apiError={apiMeta?.error}
      />
    </Modal>
  );
};
